import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4.55083 5.5C4.58882 5.53787 4.648 5.5889 4.73888 5.6521C5.04513 5.86506 5.55354 6.09716 6.27176 6.3084C7.6951 6.72703 9.72062 7 12 7C14.2794 7 16.3049 6.72703 17.7282 6.3084C18.4465 6.09716 18.9549 5.86506 19.2611 5.6521C19.352 5.5889 19.4112 5.53787 19.4492 5.5C19.4112 5.46213 19.352 5.4111 19.2611 5.3479C18.9549 5.13494 18.4465 4.90284 17.7282 4.6916C16.3049 4.27297 14.2794 4 12 4C9.72062 4 7.6951 4.27297 6.27176 4.6916C5.55354 4.90284 5.04513 5.13494 4.73888 5.3479C4.648 5.4111 4.58882 5.46213 4.55083 5.5ZM21.5 5.5V6.35504L15 14.355V17C15 19.7614 12.7614 22 10 22H9V14.355L2.5 6.35504V5.5C2.5 4.66086 3.0725 4.07064 3.59706 3.70587C4.15106 3.32064 4.88745 3.01404 5.70743 2.77287C7.36048 2.28668 9.58496 2 12 2C14.415 2 16.6395 2.28668 18.2926 2.77287C19.1125 3.01404 19.8489 3.32064 20.4029 3.70587C20.9275 4.07064 21.5 4.66086 21.5 5.5Z"}}]};

const Filter1Filled = Vue.extend<IconProps>({
  name: 'Filter1FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'filter-1-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Filter1Filled;
